// document.addEventListener("DOMContentLoaded", function() {
//   const openBtn = document.getElementById("my-acc_address-open");
//   const closeBtn = document.getElementById("my-acc_address-close");
//   const overlay = document.getElementById("cl-popup--drawer-overlay");
//   const popup = document.getElementById("my-acc_address-popup");

//   openBtn.addEventListener("click", () => {
//     popup.classList.add("active");
//     overlay.classList.add("active");
//   });

//   closeBtn.addEventListener("click", () => {
//     popup.classList.remove("active");
//     overlay.classList.remove("active");
//   });

//   overlay.addEventListener("click", () => {
//     popup.classList.remove("active");
//     overlay.classList.remove("active");
//   });
// });


document.addEventListener("DOMContentLoaded", function() {
  const openBtn = document.getElementById("my-acc_address-open");
  const overlay = document.getElementById("cl-popup--drawer-overlay");
  const popup = document.getElementById("my-acc_address-popup");
  const closeBtn = document.getElementById("my-acc_address-close");

  const allForms = document.querySelectorAll(".address-form-block");

  function showForm(formId) {
    allForms.forEach(f => f.classList.remove("active"));
    document.getElementById(formId).classList.add("active");
  }

  // Add Address
  openBtn.addEventListener("click", () => {
    showForm("AddAddressForm");
    popup.classList.add("active");
    overlay.classList.add("active");
    document.body.classList.add('body-lock-scroll');
  });

  // Edit Address
  document.querySelectorAll(".edit-address-btn").forEach(btn => {
    btn.addEventListener("click", () => {
      const addressId = btn.dataset.addressId;
      showForm(`EditAddressForm-${addressId}`);
      popup.classList.add("active");
      overlay.classList.add("active");
      document.body.classList.add('body-lock-scroll');
    });
  });

  // Close popup
  function closePopup() {
    popup.classList.remove("active");
    overlay.classList.remove("active");
    document.body.classList.remove('body-lock-scroll');
  }
  closeBtn.addEventListener("click", closePopup);
  overlay.addEventListener("click", closePopup);
});

